
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/direct-hire-placements-faq",
      function () {
        return require("private-next-pages/legal/direct-hire-placements-faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/direct-hire-placements-faq"])
      });
    }
  